import { styled, keyframes } from "@pigment-css/react";

const spin = keyframes({
  to: { transform: "rotate(360deg)" },
});

const LoadMoreContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  padding: `${theme.managementView.spacing[16]} 0`,
  borderTop: `1px solid ${theme.managementView.colors.neutral[8]}`,
}));

const Button = styled("button")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.managementView.spacing[8],
  padding: `${theme.managementView.spacing[8]} ${theme.managementView.spacing[16]}`,
  backgroundColor: "transparent",
  border: `1px solid ${theme.managementView.colors.neutral[24]}`,
  borderRadius: theme.managementView.radius[16],
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[15],
  fontWeight: theme.managementView.font.weight[500],
  color: theme.managementView.colors.neutral[100],
  cursor: "pointer",
  userSelect: "none",
  transition: "all 0.15s",

  "&:hover:not(:disabled)": {
    backgroundColor: theme.managementView.colors.neutral[4],
  },

  "&:disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },
}));

const Spinner = styled("span")(({ theme }) => ({
  width: theme.managementView.spacing[12],
  height: theme.managementView.spacing[12],
  borderRadius: "50%",
  border: `2px solid ${theme.managementView.colors.neutral[24]}`,
  borderTopColor: theme.managementView.colors.neutral[100],
  animation: `${spin} 0.8s linear infinite`,
  boxSizing: "border-box",
}));

interface LoadMoreButtonProps {
  onClick: () => void;
  label: string;
  isLoading?: boolean;
  disabled?: boolean;
  loadingLabel?: string;
}

export const LoadMoreButton = ({
  onClick,
  label,
  isLoading = false,
  disabled = false,
  loadingLabel,
}: LoadMoreButtonProps) => {
  return (
    <LoadMoreContainer>
      <Button onClick={onClick} disabled={isLoading || disabled}>
        {isLoading && <Spinner />}
        {isLoading ? (loadingLabel ?? label) : label}
      </Button>
    </LoadMoreContainer>
  );
};
